module.exports = __webpack_public_path__ + "static/media/Privacy Policy-05_26_2020-1.30da11ab.png";